/* SHERRYS Recommended — lightweight scroll-snap carousel.
   The exact collection card JS handles wishlist, image arrows and ADD TO BAG.
   This file only controls horizontal scrolling and Shopify recommendations loading. */
(() => {
  'use strict';
  if (window.__skrInstalled) return;
  window.__skrInstalled = true;

  function initCarousel(root) {
    if (root.dataset.skrInitialized === 'true') return;
    const viewport = root.querySelector('[data-skr-viewport]');
    if (!viewport) return;
    root.dataset.skrInitialized = 'true';
    const slides = [...viewport.querySelectorAll('[data-skr-slide]')];
    const previous = root.querySelector('[data-skr-prev]');
    const next = root.querySelector('[data-skr-next]');
    const progress = root.querySelector('[data-skr-progress]');
    const status = root.querySelector('[data-skr-status]');

    function update() {
      const max = Math.max(0, viewport.scrollWidth - viewport.clientWidth);
      const current = Math.min(1, Math.max(0, max ? viewport.scrollLeft / max : 0));
      if (previous) previous.disabled = current < 0.005;
      if (next) next.disabled = current > 0.995 || max < 1;
      if (progress) {
        const visible = Math.min(1, max ? viewport.clientWidth / viewport.scrollWidth : 1);
        progress.style.width = `${Math.max(visible * 100, 8)}%`;
        progress.style.transform = `translateX(${current * (100 / visible - 100)}%)`;
      }
      if (status && slides.length) {
        let index = 0;
        let best = Infinity;
        for (let i=0; i<slides.length; i++) {
          const distance = Math.abs(slides[i].offsetLeft - viewport.offsetLeft - viewport.scrollLeft);
          if (distance < best) { best = distance; index = i; }
        }
        status.textContent = `${index + 1} / ${slides.length}`;
      }
    }

    function move(direction) {
      if (!slides.length) return;
      const start = slides[0];
      const step = start.getBoundingClientRect().width + (parseFloat(getComputedStyle(root).getPropertyValue('--skr-gap')) || 5);
      viewport.scrollBy({left: step * direction, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
    }
    previous?.addEventListener('click', () => move(-1));
    next?.addEventListener('click', () => move(1));
    viewport.addEventListener('scroll', update, {passive:true});
    window.addEventListener('resize', update, {passive:true});

    // Mobile horizontal gestures belong to the outer carousel, not the card image swipe.
    // Individual product-image arrows and progress dots remain clickable.
    viewport.addEventListener('touchstart', e => e.stopPropagation(), {passive:true});
    viewport.addEventListener('touchend', e => e.stopPropagation(), {passive:true});

    update();
    requestAnimationFrame(update);
  }

  async function loadRecommendation(root) {
    const url = root.dataset.skrUrl;
    if (!url || root.dataset.skrLoading === 'true') { initCarousel(root); return; }
    root.dataset.skrLoading = 'true';
    try {
      const response = await fetch(url, {credentials:'same-origin'});
      if (!response.ok) throw new Error('Recommendation request failed');
      const html = await response.text();
      const parsed = new DOMParser().parseFromString(html, 'text/html');
      const candidate = [...parsed.querySelectorAll('[data-skr-root]')].find(element => element.dataset.skrSectionId === root.dataset.skrSectionId);
      if (!candidate) throw new Error('Recommendation section not found');
      root.innerHTML = candidate.innerHTML;
      root.removeAttribute('data-skr-url');
      initCarousel(root);
      // Keep section hidden if automatic recommendations are empty and no fallback collection is chosen.
      if (!root.querySelector('[data-skr-slide]') && !window.Shopify?.designMode) root.hidden = true;
    } catch (error) {
      root.querySelector('.skr__loading')?.replaceChildren(document.createTextNode('Recommendations are temporarily unavailable.'));
    }
    delete root.dataset.skrLoading;
  }

  // Auto-related products are below the product gallery. Request them as the
  // customer approaches this section instead of competing with initial LCP.
  const pending = new WeakSet();
  const recommendationObserver = 'IntersectionObserver' in window ? new IntersectionObserver(entries => {
    for (const entry of entries) {
      if (!entry.isIntersecting) continue;
      recommendationObserver.unobserve(entry.target);
      loadRecommendation(entry.target);
    }
  }, {rootMargin: '500px 0px', threshold: 0}) : null;

  function schedule(root) {
    if (!root) return;
    if (root.dataset.skrUrl && recommendationObserver && !window.Shopify?.designMode) {
      if (pending.has(root)) return;
      pending.add(root);
      recommendationObserver.observe(root);
    } else loadRecommendation(root);
  }
  function boot(context = document) {
    context.querySelectorAll?.('[data-skr-root]').forEach(schedule);
    if (context.matches?.('[data-skr-root]')) schedule(context);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => boot());
  else boot();
  document.addEventListener('shopify:section:load', event => boot(event.target));
})();
